// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__KDOPs","label":"Section_label__2pwXm","contentWrap":"Section_contentWrap___SiCq","footer":"Section_footer__32hf9","footerInner":"Section_footerInner__1vg6m"};